import { DayProblems } from "@app/view/shared/alerts/alert-tool/day.problems";

export class AlertData {
  totalAlerts: 0;
  dates: DayProblems[];
}
